import { render, staticRenderFns } from "./CheckboxesForm.vue?vue&type=template&id=50c988ce&scoped=true&"
import script from "./CheckboxesForm.vue?vue&type=script&lang=js&"
export * from "./CheckboxesForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxesForm.vue?vue&type=style&index=0&id=50c988ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c988ce",
  null
  
)

export default component.exports